import PageBar, { PageBarHead } from './PageBar';

export default PageBar;
export { PageBarHead };
